import * as React from 'react';
import { observer } from 'mobx-react';
import { CustomFieldType, ICustomFieldViewModel, FundVisibility} from '../../webgiving-generated';
import { FormControl } from '../form-control/form-control';
import { SelectField, TextboxField } from '../../components/form-fields';
import { ReferenceFieldsViewModel } from './reference-fields-vew-model';
import { HiddenField } from '../../components/form-fields/hidden-field';
import { IParams, Text } from '../../components/text';
import { IOptionProps } from '../../primitives/select';
import * as styles from './reference-fields.less';

@observer
export class ReferenceFields extends React.Component<{ vm: ReferenceFieldsViewModel; fundVisibility: FundVisibility }, {}> {
	render() {
		const { vm,
			fundVisibility } = this.props;

		return (
			<div>
				{vm.customFields.map((field: ICustomFieldViewModel) => {
					const { Key, Label, IsRequired, Placeholder } = field;
					const { validationError, translationParams } = vm[Key];

					let label = `{{dropDownLabel}}${IsRequired ? '' : ' (optional)'}`;
					let labelTranlationParams:IParams | undefined = {dropDownLabel: Label};

					let emptyOption: IOptionProps = { label: `-- Choose {{dropDownLabel}} --`, value: '', disableTranslation: false, translationParams: { dropDownLabel: Label }};
					let input;

					if (TranslateDefaultLabels(Label)) {
						label = Label; 
						labelTranlationParams = undefined;
						emptyOption.label = `-- Choose ${Label} --`;
						emptyOption.translationParams = undefined;
					}

					switch (field.Type) {
						case CustomFieldType.Fund:
							const { Options: funds } = field;
							const fundOptions: IOptionProps[] = funds.map((option) => ({
								value: option.Value,
								label: option.Label,
								disableTranslation: true
							}));

							const selectedValue = vm[Key].value;
							if (fundVisibility === FundVisibility.Hide ) {
								input = <HiddenField formField={vm[Key]} acceptanceTestTargetId={Label} name={fundOptions[0].value} />;
								label = '';
							} else if (fundVisibility === FundVisibility.Lock) {
								const lockedFundOption = fundOptions.filter(option => option.value === selectedValue)[0];
								return (
									<div key={Key} className="form-control-container">
										<label className="form-control-label"><Text params={ labelTranlationParams }>{label}</Text></label>
										<div className={styles.lockedFundName}>{lockedFundOption && lockedFundOption.label}</div>
									</div>
								);
							} else {
								if (!selectedValue) {
									fundOptions.unshift(emptyOption);
								}
								input = <SelectField formField={vm[Key]} options={fundOptions} acceptanceTestTargetId={Label}/>;
							}
							break;
						case CustomFieldType.DropDown:
							const { Options, DefaultOptionValue } = field;
							const selectOptions: IOptionProps[] = Options.map((option) => ({
								value: option.Value,
								label: option.Label,
								disableTranslation: true
							}));

							if (!DefaultOptionValue) {
								selectOptions.unshift(emptyOption);
							}

							input = <SelectField formField={vm[Key]} options={selectOptions} acceptanceTestTargetId={Label} />;
							break;
						case CustomFieldType.Text:
							input = <TextboxField formField={vm[Key]} name={Label} disableTranslation={true} placeholder={Placeholder} acceptanceTestTargetId={Label} />;
							break;
						case CustomFieldType.Number:
							input = <TextboxField formField={vm[Key]} name={Label} numericKeyboard disableTranslation={true} placeholder={Placeholder} acceptanceTestTargetId={Label} />;
							break;
					}

					return (
						<FormControl key={Key} label={label} translationParams={labelTranlationParams} validationTranslationParams={translationParams} validationError={validationError}>
							{input}
						</FormControl>
					);
				})}
			</div>
		);
	}
}

function TranslateDefaultLabels(str: string): boolean {
	// Large customer base use these defaults. https://pushpay.atlassian.net/browse/PP-38514
	return !!str && ["Giving Type", "Fund"].some(a => a === str);
}
